import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import ActionsEditor from '../actionsEditor.vue';
export default {
  name: 'TwinMapActionsEditor',
  components: {
    ActionsEditor
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    mapActions: {
      get() {
        return get(this.value, 'twinMapOptions.actions', []);
      },
      set(value) {
        const clone = cloneDeep(this.value);
        set(clone, 'twinMapOptions.actions', value);
        this.$emit('input', clone);
      }
    }
  }
};